import { permanentRedirect } from "~/helpers/redirect";

export default function ({ route, redirect, res, $logger }) {
  if (route.path !== "/" && route.path.endsWith("/")) {
    const { path, query, hash } = route;
    const nextPath = path.replace(/\/+$/, "") || "/";
    const queryString = new URLSearchParams(query).toString();
    const fullLocation =
      nextPath + (queryString ? `?${queryString}` : "") + (hash || "");

    permanentRedirect({ res, redirect, location: fullLocation });
  }
  if (process.server || process.env.DEPLOY_STAGE !== "production") {
    $logger.info(`[routerMiddleware] ${route.fullPath}`);
  }
}
